import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import type { TranslationTag } from '../types/i18n';

export interface GetOverrideTranslationProps {
  vegas: string | undefined;
  showVegasContent: boolean;
  ontario: string | undefined;
  showOntarioContent: boolean;
}

export const getOverrideTranslation = ({
  vegas,
  showVegasContent,
  ontario,
  showOntarioContent
}: GetOverrideTranslationProps) => {
  if (vegas && showVegasContent) {
    return { defaultMessage: vegas };
  }

  if (ontario && showOntarioContent) {
    return { defaultMessage: ontario };
  }

  return {};
};

const useRegulatoryOverride = ({ vegas, ontario }: TranslationTag) => {
  const showVegasContent = useSelector(select.cms.showVegasContent);
  const showOntarioContent = useSelector(select.cms.showOntarioContent);

  return useMemo(
    () => getOverrideTranslation({ vegas, ontario, showVegasContent, showOntarioContent }),
    [showVegasContent, vegas, showOntarioContent, ontario]
  );
};

export default useRegulatoryOverride;
